import { cn } from 'noddi-ui-common';
import { NoticeUpdatedAt, type NoticeBannerNotice } from './NoticeUpdatedAt';
import { type NoticeActorTranslations, type NoticeBannerTranslations } from './noticeBannerTranslations';
import { NOTICE_SEVERITY_BANNER_VARIANT } from './noticeSeverity';

type Props = {
  notices: NoticeBannerNotice[];
  translations?: NoticeBannerTranslations | NoticeActorTranslations;
};

const stripClassName = {
  info: 'border-blue-200 bg-blue-50 text-blue-900',
  warning: 'border-yellow-200 bg-yellow-50 text-yellow-900',
  error: 'border-red-200 bg-red-50 text-red-900'
} as const;

/** Full-width notice strip in the page flow. It scrolls away with the page. */
export const NoticeTopBanner = ({ notices, translations }: Props) => {
  if (!notices.length) {
    return null;
  }

  return (
    <div role='region' aria-label='Notices'>
      {notices.map((notice) => (
        <div
          key={notice.id}
          className={cn(
            'border-b px-4 py-2 text-center text-sm',
            stripClassName[NOTICE_SEVERITY_BANNER_VARIANT[notice.severity]]
          )}
        >
          {notice.title ? <p className='font-medium'>{notice.title}</p> : null}
          {notice.message ? <p>{notice.message}</p> : null}
          <NoticeUpdatedAt notice={notice} translations={translations} />
        </div>
      ))}
    </div>
  );
};
